.connection {
  display: flex;
  align-items: stretch;
  gap: var(--sp-4);
  padding: var(--sp-3) var(--sp-5);
}

.rail {
  flex: none;
  width: 22px;
  display: flex;
  justify-content: center;
}

.dashedLine {
  width: 0;
  border-left: var(--rail) dashed var(--border-strong);
}

.body {
  flex: 1 1 auto;
  min-width: 0;
  padding: var(--sp-2) var(--sp-4);
  background: var(--surface-2);
  border: 1px dashed var(--border);
  border-radius: var(--radius);
}

.headline {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--sp-4);
}

.duration {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-2);
}

.unknown {
  font-size: var(--fs-sm);
  color: var(--text-3);
}

.note {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.warnings {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  margin: var(--sp-2) 0 0;
  padding: 0;
  list-style: none;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  align-self: flex-start;
  padding: 1px var(--sp-3);
  border-radius: var(--radius);
  font-size: var(--fs-xs);
  border: var(--bw) solid transparent;
}

.badge.warn {
  background: var(--warn-bg);
  box-shadow: var(--glow-warn);
  border-color: var(--warn-border);
  color: var(--warn);
}

.badge.error {
  background: var(--error-bg);
  box-shadow: var(--glow-error);
  border-color: var(--error-border);
  color: var(--error);
}
